import { Tooltip } from '@/components/common/tooltip';
import { textCell } from '@/components/data/data-table';

import styles from './applicable-components-cell.module.scss';

type ComponentRef = { id: string; name: string };

export function ApplicableComponentsCell({ components }: { components: ComponentRef[] }) {
  if (components.length === 0) return null;

  const [first, ...rest] = components;
  if (rest.length === 0) {
    return <span className={styles.name}>{textCell(first.name)}</span>;
  }

  const hidden = (
    <span className={styles.list}>
      {rest.map((c) => (
        <span key={c.id}>{c.name}</span>
      ))}
    </span>
  );

  return (
    <span className={styles.cell}>
      <span className={styles.name}>{textCell(first.name)}</span>
      <Tooltip appearance="dark" placement="bottom" title={hidden}>
        <button
          type="button"
          className={styles.badge}
          aria-label={`${rest.length} more components`}
        >
          +{rest.length}
        </button>
      </Tooltip>
    </span>
  );
}
